<template>
  <div class="event-break" :class="[type, { hideOpenHours, openHours }]">
    <div class="content">
      <span>{{ $t('events.event-break.break') }}</span>
      <span>
        <img src="@/assets/icons/clock.svg" alt="clock" />
        {{ dur }}
      </span>
      <span v-if="openHours">{{ $t('events.event-break.or') }}</span>
    </div>
    <OpenHours :class="type" @change="hideOpenHours = $event" :event="openHours" v-if="openHours" />
  </div>
</template>

<script>
import OpenHours from '@/components/events/OpenHours'
import moment from 'moment'
import isActualEvent from '../../mixins/isActualEvent'

export default {
  name: 'EventBreak',
  components: { OpenHours },
  mixins: [isActualEvent],
  props: {
    openHours: {},
    type: String,
    duration: Number,
  },
  data: () => ({
    hideOpenHours: false,
  }),
  computed: {
    dur() {
      const min = moment.duration(this.duration).asMinutes()
      return `${min} min`
    },
  },
}
</script>

<style lang="scss">
.event-break {
  position: relative;

  & + .event-break:not(.vertical) {
    margin-top: 16px;

    .content {
      border-radius: 0 !important;
    }
  }

  .content {
    @include flexCenter;
    height: 22px;
    font-weight: bold;
    font-size: 12px;
    color: $dark;
    transition: all 0.25s;

    > span {
      @include flexCenter;
      margin: 0 3px;

      img {
        margin-right: 3px;
      }
    }
  }

  &.openHours:not(.vertical) {
    .content {
      margin: 12px 0;
      border-radius: 5px;
      height: 34px;

      > span {
        margin: 0;

        &:nth-child(2) {
          margin-right: 12px;
          margin-left: 7px;
        }
      }
    }

    &.hideOpenHours .content {
      justify-content: flex-start;
    }

    &:not(.hideOpenHours) .content {
      justify-content: center;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: 0;
    }
  }

  &:not(.vertical) .open-hours-block {
    padding-right: 20px;

    &:not(.hide) {
      margin-top: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &.hide {
      position: absolute;
      right: 8px;
      top: 6px + 8px;
      margin: -8px 0 0;

      .hosts {
        margin-right: 20px;
      }

      .participants {
        display: none;
      }
    }
  }

  &.vertical {
    @include PC {
      margin: 0 7px;
      height: 100%;
    }

    .content {
      @include PC {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin: 0;
        height: 100%;
        width: 58px;
        padding: 140px 8px 8px;

        span {
          white-space: nowrap;
        }
      }
    }

    &.openHours {
      .content {
        @include mobile {
          height: 249px;
          align-items: flex-start;
          padding-top: 13px;
          margin: 7px 0;
          border-radius: 5px;
        }

        @include PC {
          width: 170px;
          padding-top: 80px;

          span:last-child {
            margin-top: 14px;
          }
        }
      }
    }

    .open-hours-block {
      margin: 0;
      position: absolute;
      right: 6px;
      left: 6px;
      bottom: 6px;

      .head {
        .title {
          margin: 0 0 13px;
          min-height: unset;
        }
      }

      .participants {
        @include mobile {
          flex-direction: row;
          align-items: center;

          .users {
            margin-bottom: 0;
          }
        }
      }

      @include PC {
        height: 292px;
        width: auto;
        margin: 0;
      }
    }
  }
}
</style>
